import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux';
import { setWpm, setFarnsworthWpm, setDisplay, setType, setTotalCharRepeats, setUseLetters, setUseNumbers, setUseSymbols, toggleDrawer } from '../settings-panel/store/settingsSlice';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DISPLAY_MODES, MODES } from '../../app/classes/constants';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Button } from '@mui/material';

function SettingsPanel(props){

    const wpm = useSelector((state) => state.settings.wpm);
    const farnsworthWpm = useSelector((state) => state.settings.farnsworthWpm);
    const display = useSelector((state) => state.settings.display);
    const type = useSelector((state) => state.settings.type);
    const isPlaying = useSelector((state) => state.settings.isPlaying);
    const totalCharRepeats = useSelector((state) => state.settings.totalCharRepeats);
    const useLetters = useSelector((state) => state.settings.useLetters);
    const useNumbers = useSelector((state) => state.settings.useNumbers);
    const useSymbols = useSelector((state) => state.settings.useSymbols);

    const dispatch = useDispatch();

    const handleWpmChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            dispatch(setWpm(newValue));
        }        
    };

    const handleFwWpmChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            dispatch(setFarnsworthWpm(newValue));
        }        
    };

    const displayModes = [];
    const modes = [];

    for (const [key, value] of Object.entries(DISPLAY_MODES)) {
        displayModes.push(<MenuItem key={`menu_DISPLAY_MODES_${key}`} value={value.id}>{value.label}</MenuItem>);
    }

    for (const [key, value] of Object.entries(MODES)) {
        modes.push(<MenuItem key={`menu_MODES_${key}`} value={value.id}>{value.label}</MenuItem>);
    }

    return (
        
        <div className="m-8">

            {isPlaying &&
                <div className="text-center text-lg">
                    <strong>You have to stop the CW player to be able to change the settings</strong>
                </div>
            }

            {(!isPlaying) && <Stack
                direction="column"
                //divider={<Divider orientation="horizontal" flexItem />}
                spacing={4}
                alignItems={"flex-start"}
            >

                <Box  sx={{ width: '100%', textAlign: 'right' }}>
                    <Button color='primary' variant='contained' onClick={() => dispatch(toggleDrawer())}>
                        Close settings
                    </Button>
                </Box>

                {(type !== 'TOP_WORDS' && type !== 'SEQ_TOP_WORDS' && type !== 'FULL_TOP_WORDS' && type !== 'FULL_SEQ_TOP_WORDS') &&<Box  sx={{ width: '100%' }}>

                    <Stack
                        direction="row"
                        spacing={0}
                    >
                        <FormControlLabel control={<Checkbox checked={useLetters} onChange={(e) => dispatch(setUseLetters(e.target.checked))} />} label="Letters" />
                        <FormControlLabel control={<Checkbox checked={useNumbers} onChange={(e) => dispatch(setUseNumbers(e.target.checked))} />} label="Numbers" />
                        <FormControlLabel control={<Checkbox checked={useSymbols} onChange={(e) => dispatch(setUseSymbols(e.target.checked))} />} label="Symbols" />
                    </Stack>

                </Box>}

                <Box  sx={{ width: '100%' }}>

                    <FormControl fullWidth>
                        <InputLabel id="type-label">Mode</InputLabel>
                        <Select
                            labelId="type-label"
                            id="label"
                            value={type}
                            label="Type"
                            onChange={(e) => dispatch(setType(e.target.value)) }
                        >
                            {modes}
                        </Select>
                    </FormControl>

                </Box>

                { (type === 'TEACH_ME_CW'|| type === 'TOP_WORDS' || type === 'SEQ_TOP_WORDS' || type === 'FULL_TOP_WORDS' || type === 'FULL_SEQ_TOP_WORDS') && <Box  sx={{ width: '100%' }}>
                <Typography id="wpm-slider" gutterBottom>
                        Repeat {(type === 'TEACH_ME_CW' ? 'character' : 'word')}: {totalCharRepeats} times
                    </Typography>
                    <Slider
                        value={totalCharRepeats}
                        min={1}
                        step={1}
                        max={10}
                        onChange={(e) => dispatch(setTotalCharRepeats(e.target.value)) }
                        valueLabelDisplay="auto"
                        aria-labelledby="wpm-slider"
                    />
                </Box>}

                {(type !== 'TOP_WORDS' && type !== 'SEQ_TOP_WORDS' && type !== 'FULL_TOP_WORDS' && type !== 'FULL_SEQ_TOP_WORDS' ) &&<Box  sx={{ width: '100%' }}>

                    <FormControl fullWidth>
                        <InputLabel id="display-label">Display</InputLabel>
                        <Select
                            labelId="display-label"
                            id="label"
                            value={display}
                            label="Display"
                            onChange={(e) => {
                                dispatch(setDisplay(e.target.value));                            
                            } }
                        >
                            {displayModes}
                        </Select>
                    </FormControl>

                </Box> }

                <Box  sx={{ width: '100%' }}>
                    <Typography id="wpm-slider" gutterBottom>
                        Speed: {wpm} WPM
                    </Typography>
                    <Slider
                        value={wpm}
                        min={5}
                        step={1}
                        max={30}
                        onChange={handleWpmChange}
                        valueLabelDisplay="auto"
                        aria-labelledby="wpm-slider"
                    />
                </Box>

                <Box  sx={{ width: '100%' }}>
                    <Typography id="fwpm-slider" gutterBottom>
                        {(type !== 'TOP_WORDS' && type !== 'RANDOM_GROUPS')&& `Farnsworth: ${farnsworthWpm} WPM`}
                        {(type === 'TOP_WORDS' || type === 'RANDOM_GROUPS')&& `Spaces between words: ${farnsworthWpm}`}
                    </Typography>
                    <Slider
                        value={farnsworthWpm}
                        min={1}
                        step={1}
                        max={30}
                        onChange={handleFwWpmChange}
                        valueLabelDisplay="auto"
                        aria-labelledby="fwpm-slider"
                    />
                </Box>                          
            </Stack>}
        </div>
    );
}

export default SettingsPanel;